import { reduce } from 'lodash-es';

export interface IUserRole {
  value: string;
  label: string;
}

export enum Role {
  // Администратор
  ADMIN = 'ADMIN',
  // Модератор
  MODERATOR = 'MODERATOR',
  // Аналитик
  ANALYST = 'ANALYST',
  // ЦРО
  STUDENT_AFFAIRS_OFFICER = 'STUDENT_AFFAIRS_OFFICER',
}

export const USER_ROLES = {
  ADMIN: 'Администратор',
  MODERATOR: 'Модератор',
  '': 'Пользователь',
  STUDENT_AFFAIRS_OFFICER: 'Специалист по работе с обучающимися',
  ANALYST: 'Аналитик',
};

export const USER_ROLES_LIST: IUserRole[] = reduce(
  USER_ROLES,
  (prev: IUserRole[], label, value) => {
    if (value !== '') {
      prev.push({ value, label });
    }

    return prev;
  },
  [],
);
